import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function Login() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("role", data.role);
      localStorage.setItem("username", data.username);
      navigate(data.role === "admin" ? "/dashboard" : "/calculo");
    } catch {
      setError("Usuário ou senha inválidos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow" style={{ width: 400 }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <h4 className="fw-bold text-primary">Sistema de Comissões</h4>
            <small className="text-muted">Calculadora automática</small>
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Usuário</label>
              <input
                className="form-control"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                required
                autoFocus
              />
            </div>
            <div className="mb-2">
              <label className="form-label fw-semibold">Senha</label>
              <input
                type="password"
                className="form-control"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
            </div>

            <div className="text-end mb-3">
              <button
                type="button"
                className="btn btn-link btn-sm p-0 text-decoration-none"
                onClick={() => setShowForgot(true)}
              >
                Esqueci minha senha
              </button>
            </div>

            <button className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>

      {/* Modal: Esqueci minha senha */}
      {showForgot && (
        <div
          className="modal show d-block"
          style={{ background: "rgba(0,0,0,0.55)" }}
          onClick={(e) => e.target === e.currentTarget && setShowForgot(false)}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">🔑 Recuperar Acesso</h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={() => setShowForgot(false)}
                />
              </div>
              <div className="modal-body">

                {/* Usuário operacional */}
                <div className="card mb-3 border-secondary">
                  <div className="card-header fw-bold bg-light">
                    👤 Sou um usuário operacional
                  </div>
                  <div className="card-body text-muted small">
                    <p className="mb-1">
                      Contate o <strong>administrador do sistema</strong> para redefinir sua senha.
                    </p>
                    <p className="mb-0">
                      O administrador acessa <strong>Configurações → Usuários</strong> e clica em
                      <strong> "Redefinir Senha"</strong> ao lado do seu nome.
                    </p>
                  </div>
                </div>

                {/* Admin */}
                <div className="card border-primary">
                  <div className="card-header fw-bold bg-primary text-white">
                    🛡 Sou o administrador
                  </div>
                  <div className="card-body small">
                    <p className="fw-semibold mb-2">Opção 1 — Via variável de ambiente (recomendado):</p>
                    <ol className="mb-3">
                      <li>Abra o arquivo <code>.env</code> na pasta do projeto.</li>
                      <li>
                        Altere o valor de{" "}
                        <code>FIRST_ADMIN_PASSWORD=NovaSenh@Forte</code>
                      </li>
                      <li>Reinicie o serviço: <code>docker compose restart backend</code></li>
                      <li>
                        Na próxima inicialização, a senha é atualizada automaticamente no banco.
                      </li>
                    </ol>

                    <p className="fw-semibold mb-2">Opção 2 — Via container (acesso direto ao banco):</p>
                    <pre className="bg-light p-2 rounded small mb-0" style={{ fontSize: 11 }}>
{`docker compose exec backend python -c "
from app.database import SessionLocal
from app.models.user import User
from app.utils.auth import hash_password
db = SessionLocal()
u = db.query(User).filter(User.username=='admin').first()
u.hashed_password = hash_password('NovaSenh@Forte')
db.commit()
print('OK')
"`}
                    </pre>
                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowForgot(false)}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
